import _isEmpty from "lodash/isEmpty"
import { store } from "@/store"
import { showToast } from "@/store/features/genericSlice"

export const getDefaultStateData = pdpData => {
  return {
    isProductVariantClicked: false,
    clickedProductVariant: false,
    selectedSku: "",
    customerFacingSKU: "",
    productDetailData: pdpData ? pdpData : {},
    docId: "",
    fusionQueryId: "",
    masterSku: "",
    options: {},
    facetLabels: [],
    currOptions: {},
    selectMoreTooltipData: {},
    reqCartData: [],
    ctData: {},
    persona: "",
    toaster: { show: false, message: "", mobileOnly: false },
    reverseGeo: "",
    jsonFileUrl: "",
    zipCodeData: [],
    installationData: [],
    designServiceData: [],
    servicesData: {},
    installationDataFromProp: [],
    designServiceDataFromProp: [],
    availableStock: 0,
    promoTitle: null,
    promoDescription: false,
    enablePromo: false,
    viewLoader: pdpData ? true : false,
    findInstallerPath: "",
    loadShowEvent: false,
    installerArea: "",
    statesData: [],
    mboxes: [],
    imageClickCounter: 1,
    variantData: [],
  }
}

export const getFormatedImages = data => {
  const { variantImageLabels, variantImageURLs, authorData } = data
  const images = []
  if (authorData) {
    for (let i = 0; i < variantImageURLs.length; i++) {
      const urlPaths = variantImageURLs[i].split("?")[0]?.split("/")
      const assetId = urlPaths[urlPaths.length - 1]
      images.push({
        label: variantImageLabels[i] ?? "",
        assetId,
        url: variantImageURLs[i] ?? "",
      })
    }
  }
  return images
}

export const getPdpProps = (data = {}) => {
  const {
    state: {
      productDetailData = {},
      selectedSku = "",
      availableStock = 0,
      masterSku = "",
      variantData = [],
      ctData = {},
      loadShowEvent,
      clickedProductVariant,
    },
    customerSkus,
    selectedColor,
    isParts,
    currencySign,
    requiredItemstoInstall,
    colorsData,
    comparedProducts,
    disableEcommerce,
    favorites,
    superSku,
    cartLoaded,
    cart,
    pricesData,
    // locale,
    discountedPrices,
  } = data

  const {
    title_s: title = "",
    productName_s: productNames = "",
    features_s: features,
    RegionBrandName_s: regionBrandNames = "",
    ProductBrandName_s: productBrandNames = [],
    ProductDescriptionProductShort_s: desc,
    ProductNarrativeDescription_s: narrativeDescription = "",
    CustomerFacingBrand_s: customerBrandName = "",
    productRegionAllVariantDiscontinued_b: discontinuedProduct = false,
    ProductProductRecommendedAccessories_ss:
      ProductRequiredAccessoriesGroupsList = [],
    RegionOnBackOrder_s: backOrder = "No",
    ProductOverallLengthInches_s: productOverallLength = 0,
    ProductOverallWidthInches_s: productOverallWidth = 0,
    ProductOverallHeightInches_s: productOverallHeight = 0,
    ProductWebFeatures_ss: productWebFeatures = [],
    ProductPriceSpiderIncluded_s: productPriceSpiderIncluded,
    ProductFreightPolicyType_s: freightPolicyType = "",
    category1_s: category1s,
    ProductBrandNameDisplay_t: productBrandNameDisplayt,
    ctProductType_s: ctProductTypes,
    primaryBundleSKU_s: primaryBundleSKUs = "",
  } = productDetailData

  const { RegionSpecialOrder_s: specialOrder = "No" } =
    variantData.find(item => item.sku_s === selectedSku) ?? {}

  const isBundleProduct = Boolean(primaryBundleSKUs)

  const productName =
    isBundleProduct || isParts ? productNames : regionBrandNames

  const name = productName ? productName : productNames

  const productDisc = isBundleProduct ? title : desc

  return {
    features,
    sku: selectedSku,
    customerFacingSKU: customerSkus[selectedSku],
    name,
    desc: productDisc,
    narrativeDescription,
    customerBrandName,
    currencySign,
    discontinuedProduct: discontinuedProduct,
    ProductRequiredAccessoriesGroupsList,
    stickyHeaderProps: {
      selectedSku,
      title: isParts
        ? productNames
        : isBundleProduct
        ? productNames
        : productBrandNames,
      description: isBundleProduct ? title : desc,
      itemStatus: "available",
      color: {
        label: selectedColor,
        url: colorsData.find(item => item.id === selectedSku)?.colorUrl,
      },
    },
    requiredItems: requiredItemstoInstall ?? [],
    productOnStock: availableStock,
    colorsData: colorsData,
    addToCartProps: {
      compareChecked: Boolean(
        comparedProducts.find(prod => masterSku === prod["masterSKU_s"])
      ),
      backOrder,
      specialOrder,
    },
    detailsProps: {
      length: productOverallLength,
      width: productOverallWidth,
      height: productOverallHeight,
      dimensionUnit: "in",
      detailsData: productWebFeatures,
    },
    ProductPriceSpiderIncluded_s:
      productPriceSpiderIncluded === "true" && !disableEcommerce ? true : false,
    isProjectPack: productDetailData["SKUIsProjectPack_s"] === "Yes",
    freightPolicyType,
    isFavorite:
      !_isEmpty(favorites) &&
      favorites?.lineItems.find(
        vl => vl.productId === ctData.id && vl.variant?.sku === selectedSku
      )
        ? true
        : false,
    favItem: favorites?.lineItems ?? [],
    ctProductId: ctData.id,
    superSku,
    loadShowEvent: cartLoaded || loadShowEvent, // this should set to true at least once
    cart,
    clickedProductVariant,
    selectedColor: selectedColor,
    businessUnitName: category1s || category1s,
    globalDiscount: Number(
      (pricesData[selectedSku] - (discountedPrices[selectedSku] ?? 0)).toFixed(
        2
      )
    ),
    productSaleable: true,
    productPartnerBuyNow: false,
    productCollectionsName: productBrandNameDisplayt,
    productType: ctProductTypes,
  }
}

export const showToaster = mssg => {
  store.dispatch(
    showToast({
      message: mssg,
      isVisible: true,
    })
  )
  setTimeout(
    () =>
      store.dispatch(
        showToast({
          message: mssg,
          isVisible: false,
        })
      ),
    3000
  )
}

export const getFirstSkuColor = data => {
  const colorList = []
  const newData = data.filter(e => {
    if (!colorList.includes(e.label)) {
      colorList.push(e.label)
      return e
    }
  })

  return newData.map(e => {
    const newData = data.filter(el => el.label === e.label).map(a => a.value)
    return { ...e, skus: newData }
  })
}

export const getSelectedColor = (colorsData, sku) => {
  const { label = "" } =
    colorsData.find(item => {
      const { skus = [], id = "" } = item
      if (id === sku || skus?.includes(sku)) {
        return item
      }
    }) ?? {}
  return label
}
